import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const deviceListRoutes = {
  path: 'device-list',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.device.list'),
  },
  children: [
    {
      path: '',
      name: 'deviceList',
      component: () => lazyLoadView(import('@views/DeviceList/list.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
      },
    },
    {
      path: ':id',
      name: 'deviceDetail',
      component: () => lazyLoadView(import('@views/DeviceList/details.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.device.detail'),
      },
    },
  ],
}

export default deviceListRoutes
